/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'coal-icon': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<path pid="0" d="M26.224 33.776L23.925 58.64 7 40.044l19.224-6.268zM56 40.985L46.179 60H25.91l2.403-26.328L56 40.985zM48.269 9.85l-8.254 5.434V4.313L48.27 9.85zM37.925 4v12.85L27.477 30.432 17.97 13.925 37.925 4zM56.105 38.896l-26.955-7.21 10.552-13.79 9.821-6.373 6.582 27.373zM25.806 31.686L7 37.85l9.612-22.044 9.194 15.88z" _fill="#0B2C62"/>'
  }
})
